/**
 * Text content of `node`'s direct child element named `tagName`, or null.
 *
 * Replacement for `node.querySelector(tag)?.textContent` on P6 XML: the P6
 * schema keeps every field element a direct child of its business object, and
 * querySelector both invokes the CSS selector engine per call and matches any
 * descendant — so on exports with tens of thousands of nodes (~8 field reads
 * each) it dominated parse time and could even match a same-named field of a
 * nested element.
 */
export function childElement(node, tagName) {
  for (let child = node.firstElementChild; child; child = child.nextElementSibling) {
    if (child.localName === tagName) return child;
  }
  return null;
}

export function childText(node, tagName) {
  return childElement(node, tagName)?.textContent ?? null;
}
